export type PatientInfo = {
  contactTime?: string;
  birthDate?: string;
};

export const emptyPatientInfo: PatientInfo = {};
